import React from 'react'
import './Unauthorized.css';

const Unauthorized = () => {
    return (
        <div className="unauthorized">
            <div className="unauthorized-wrapper">
                <h2>Unauthorized Access</h2>
                <p>You do not have permission to view this page. Please log in again or contact support.</p>
            </div>
        </div>
    )
}

export default Unauthorized